import { render, staticRenderFns } from "./index.vue?vue&type=template&id=54b43b6c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=54b43b6c&prod&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=54b43b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b43b6c",
  null
  
)

export default component.exports